// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import GlobalPopupManager from './components/common/GlobalPopupManager';
import GlobalStreamingPopup from './components/common/GlobalStreamingPopup';
import GlobalBlastQueueWidget from './components/common/GlobalBlastQueueWidget';
import GlobalActiveShippingWidget from './components/common/GlobalActiveShippingWidget';
import AutoVersionUpdater from './components/common/AutoVersionUpdater';
import PrivateRoute from './utils/PrivateRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import ForgotPasswordPage from './pages/LoginForgotPasswordPage';
import ResetPasswordPage from './pages/LoginResetPasswordPage';
import SecurityDeviceActionPage from './pages/SecurityDeviceActionPage';


import Home from './pages/Home';
import DesktopLandingPage from './pages/DesktopLandingPage';
import useMediaQuery from './hooks/useMediaQuery';
import CrowdfundingMainPage from './pages/CrowdfundingMainPage';
import CrowdfundingCampaignDetail from './pages/CrowdfundingCampaignDetail';
import CrowdfundingDonationPage from './pages/CrowdfundingDonationPage';
import CrowdfundingDonationHistoryPage from './pages/CrowdfundingDonationHistoryPage';
import CrowdfundingPaymentConfirmation from './pages/CrowdfundingPaymentConfirmation';

import EcommerceMainPage from './pages/EcommerceMainPage';
import EcommerceWishlistPage from './pages/EcommerceWishlistPage';
import EcommerceCartPage from './pages/EcommerceCartPage';
import EcommerceOrderHistoryPage from './pages/EcommerceOrderHistoryPage';
import EcommerceProductDetail from './pages/EcommerceProductDetail';
import EcommerceCheckoutPage from './pages/EcommerceCheckoutPage';
import EcommerceCheckoutSinergy from './pages/EcommerceCheckoutSinergy';
import EcommercePaymentConfirmation from './pages/EcommercePaymentConfirmation';

import ArticleListPage from "./pages/ArticleListPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import ArticleCreatePage from './pages/ArticleCreatePage';
import ArticleUploadImagesPage from './pages/ArticleUploadImagesPage';

import EcourseMainPage from './pages/EcourseMainPage';
import EcourseCourseDetail from './pages/EcourseCourseDetail';
import EcourseJoinCoursePage from './pages/EcourseJoinCoursePage';
import EcoursePaymentConfirmation from './pages/EcoursePaymentConfirmation';
import EcourseViewerPage from './pages/EcourseViewerPage';

import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailedPage from './pages/PaymentFailedPage';
import PaymentPendingPage from './pages/PaymentPendingPage';

import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import AcademyMain from './pages/AcademyMain';
import ActivityListPage from './pages/ActivityListPage';
import ActivityDetailPage from './pages/ActivityDetailPage';
import MeetingViewPage from './pages/MeetingViewPage';
import DashboardUserPage from './pages/admin/DashboardUserPage';
import DashboardEventPage from './pages/admin/DashboardEventPage';
import DashboardAboutUsPage from './pages/admin/DashboardAboutUsPage';
import EventLandingPage from './pages/EventLandingPage';
import EventSubmissionPage from './pages/EventSubmissionPage';
import EventDetailPage from './pages/EventDetailPage';
import EventRegistrationSubmissionPage from './pages/admin/EventRegistrationSubmissionPage';
import EventScanPage from './pages/EventScanPage';

import DigitalProductListPage from './pages/DigitalProductListPage';
import DigitalProductDetailPage from './pages/DigitalProductDetailPage';
import DigitalProductCheckoutPage from './pages/DigitalProductCheckoutPage';
import DigitalProductPaymentPage from './pages/DigitalProductPaymentPage';

import DashboardPage from './pages/DashboardPage';
import DashboardDigitalProductsPage from './pages/DashboardDigitalProductsPage';
import DashboardEcourseListPage from './pages/DashboardEcourseListPage';
import DashboardEcourseFormPage from './pages/DashboardEcourseFormPage';
import DashboardEcourseMaterialsPage from './pages/DashboardEcourseMaterialsPage';
import DashboardEcourseProgressPage from './pages/DashboardEcourseProgressPage';
import SellerProfilePage from './pages/SellerProfilePage';
import StoreProfilePage from './pages/StoreProfilePage';
import DashboardShopSettingsPage from './pages/DashboardShopSettingsPage';
import DashboardAdminWithdrawalsPage from './pages/DashboardAdminWithdrawalsPage';
import DashboardRealizationPage from './pages/admin/DashboardRealizationPage';
import DashboardPartnersPage from './pages/admin/DashboardPartnersPage';
import DashboardTestimonialsPage from './pages/admin/DashboardTestimonialsPage';
import DashboardActivitiesPage from './pages/admin/DashboardActivitiesPage';
import ChatListPage from './pages/chat/ChatListPage';
import ChatWindowPage from './pages/chat/ChatWindowPage';
import AdminAllProductsPage from './pages/admin/AdminAllProductsPage';
import AdminAllCoursesPage from './pages/admin/AdminAllCoursesPage';
import AdminConsultantSettingsPage from './pages/admin/AdminConsultantSettingsPage';
import AdminTransactionHistoryPage from './pages/admin/AdminTransactionHistoryPage';
import DashboardAdminIncomingFundsPage from './pages/admin/DashboardAdminIncomingFundsPage';
import DashboardAdminForumPage from './pages/admin/DashboardAdminForumPage';
import DashboardRoleManagementPage from './pages/admin/DashboardRoleManagementPage';
import DashboardKaderisasiPage from './pages/admin/DashboardKaderisasiPage';
import DashboardLiveStreamingPage from './pages/admin/DashboardLiveStreamingPage';
import DashboardAdminCampaignApprovalPage from './pages/admin/DashboardAdminCampaignApprovalPage';
import DashboardAdminServiceApprovalPage from './pages/admin/DashboardAdminServiceApprovalPage';
import DashboardAdminArticleManagementPage from './pages/admin/DashboardAdminArticleManagementPage';
import DashboardAdminCampaignManagementPage from './pages/admin/DashboardAdminCampaignManagementPage';
import DashboardMyCampaignsPage from './pages/DashboardMyCampaignsPage';
import DashboardMyServicesPage from './pages/DashboardMyServicesPage';
import ServicesMainPage from './pages/ServicesMainPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import DashboardMyEventsPage from './pages/DashboardMyEventsPage';
import DashboardArticleEditorPage from './pages/DashboardArticleEditorPage';
import ZISSubmissionPage from './pages/ZISSubmissionPage';
import ZISHistoryPage from './pages/ZISHistoryPage';
import AdminZISConfigPage from './pages/admin/AdminZISConfigPage';
import AdminZISVerifyPage from './pages/admin/AdminZISVerifyPage';
import AdminPaymentSettingsPage from './pages/admin/AdminPaymentSettingsPage';
import DashboardWhatsNewPage from './pages/admin/DashboardWhatsNewPage';
import DashboardBroadcastWAPage from './pages/admin/DashboardBroadcastWAPage';
import DashboardBroadcastEmailPage from './pages/admin/DashboardBroadcastEmailPage';
import DashboardWhatsAppSettingsPage from './pages/admin/DashboardWhatsAppSettingsPage';
import WhatsNewPage from './pages/WhatsNewPage';
import WhatsNewPopup from './components/whatsnew/WhatsNewPopup';
import PublicLandingPageView from './pages/PublicLandingPageView';
import DashboardLandingPagesPage from './pages/DashboardLandingPagesPage';
import DashboardLandingPagesBuilderPage from './pages/DashboardLandingPagesBuilderPage';
import DashboardAdminLandingPageSettingsPage from './pages/admin/DashboardAdminLandingPageSettingsPage';


import ForumMainPage from './pages/ForumMainPage';
import ForumThreadDetail from './pages/ForumThreadDetail';
import StreamingPage from './pages/StreamingPage';

import DashboardSinergySellersPage from './pages/DashboardSinergySellersPage';
import DashboardSinergySellerOrdersPage from './pages/DashboardSinergySellerOrdersPage';
import DashboardSinergyAdminPage from './pages/admin/DashboardSinergyAdminPage';
import BaeRunLandingPage from './pages/BaeRunLandingPage';
import AdminJitsiMeetPage from './pages/AdminJitsiMeetPage';
import AdminPhotoFramerPage from './pages/admin/AdminPhotoFramerPage';
import DashboardEventRecapPage from './pages/admin/DashboardEventRecapPage';
import DashboardDonationManagementPage from './pages/admin/DashboardDonationManagementPage';
import DashboardAnnouncementsPage from './pages/admin/DashboardAnnouncementsPage';
import ActivityCalendarPage from './pages/admin/ActivityCalendarPage';
import BusinessDataListPage from './pages/BusinessDataListPage';
import BusinessDataFormPage from './pages/BusinessDataFormPage';
import DashboardAdminBusinessPage from './pages/admin/DashboardAdminBusinessPage';
import ExpeditionTestPage from './pages/admin/ExpeditionTestPage';
import DashboardMeetingsPage from './pages/DashboardMeetingsPage';
import MeetingSubmissionPage from './pages/MeetingSubmissionPage';
import MeetingManagementPage from './pages/MeetingManagementPage';
import DashboardHeroBannersPage from './pages/admin/DashboardHeroBannersPage';
import DashboardUserAgreementPage from './pages/admin/DashboardUserAgreementPage';
import DashboardAdminMaintenancePage from './pages/admin/DashboardAdminMaintenancePage';
import CalendarWidgetPage from './pages/widget/CalendarWidgetPage';

import ProfileNotice from './components/common/ProfileNotice';
import UserAgreementModal from './components/common/UserAgreementModal';
import UnreviewedOrdersModal from './components/modals/UnreviewedOrdersModal';
import MaintenanceScreen from './components/common/MaintenanceScreen';
import SlideOverCartDrawer from './components/layout/SlideOverCartDrawer';

import { ResponsiveLayout, MobileContainer } from './components/layout/ResponsiveLayout';
import ScrollToTop from './components/layout/ScrollToTop';
import NotificationService from './services/NotificationService';
import { getSessions } from './services/chatApi';
import { forumApi } from './services/forumApi';
import axios from 'axios';

const NotificationHandler = () => {
  const location = useLocation();
  const lastSessionData = React.useRef({});
  const isFetching = React.useRef(false);
  const pathRef = React.useRef(location.pathname);
  const currentUser = JSON.parse(localStorage.getItem('user'));

  // Update pathRef whenever location changes, without re-triggering the interval effect
  React.useEffect(() => {
    pathRef.current = location.pathname;
  }, [location.pathname]);

  React.useEffect(() => {
    // Request push notification permission for all visitors, particularly mobile browsers/APK builders, as requested.
    NotificationService.requestPermission();
  }, []);

  React.useEffect(() => {
    if (!currentUser) return;

    const checkNewMessages = async () => {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const res = await getSessions();
        const sessions = res.data;
        const activeSessionId = pathRef.current.split('/chat/')[1];

        sessions.forEach(session => {
          const lastMsg = session.last_message;
          if (lastMsg && !lastMsg.is_read && lastMsg.sender !== currentUser.id) {
            const prevLastMsgId = lastSessionData.current[session.id];

            // Don't notify if we are currently in that chat window
            if (session.id.toString() !== activeSessionId && lastMsg.id !== prevLastMsgId) {
              const isStore = session.session_type === 'store' || session.session_type === 'order' || !!session.product || !!session.order;
              const isCurrentSeller = session.seller_details && (session.seller_details.id === currentUser?.id || session.seller_details.username === currentUser?.username);
              let senderName = '';
              if (isStore) {
                if (isCurrentSeller) {
                  senderName = session.user_details?.name_full || session.user_details?.username || 'Pelanggan';
                } else {
                  senderName = session.seller_details?.shop_name || session.seller_details?.name_full || session.seller_details?.username || 'Toko';
                }
              } else {
                senderName = session.consultant_details?.name_full || session.consultant_details?.username || (session.category_name ? `Konsultasi ${session.category_name}` : 'Pakar Syariah');
              }
              NotificationService.showNotification(`Pesan Baru dari ${senderName}`, {
                body: lastMsg.content || 'Mengirim file...',
                url: `/chat/${session.id}`
              });
            }
          }
          // Update tracker
          if (session.last_message) {
            lastSessionData.current[session.id] = session.last_message.id;
          }
        });

        // Check forum mentions
        try {
          const forumRes = await forumApi.getNotifications();
          const pNotifs = forumRes.data;

          pNotifs.forEach(async (notif) => {
            if (!notif.is_read) {
              NotificationService.showNotification(`Mention dari @${notif.sender_name}`, {
                body: notif.snippet || `Anda disebut di '${notif.thread_title}'`,
                url: `/forum/${notif.thread_slug}`
              });
              await forumApi.markNotificationRead(notif.id);
            }
          });
        } catch (fe) {
          console.error('Failed to poll forum mentions:', fe);
        }

        // Check live stream notifications
        try {
          const streamNotifsRes = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/streaming/notifications/`,
            { headers: { Authorization: `Bearer ${currentUser?.access}` } }
          );
          const streamNotifs = streamNotifsRes.data;
          for (const notif of streamNotifs) {
            NotificationService.showNotification(`🔴 Live Stream Dimulai!`, {
              body: `Live stream '${notif.stream_title}' untuk event '${notif.event_title}' sedang berlangsung.`,
              url: `/event/${notif.event_slug}`
            });
            // Mark notification as read
            await axios.post(
              `${process.env.REACT_APP_API_BASE_URL}/api/streaming/notifications/${notif.id}/mark-read/`,
              {},
              { headers: { Authorization: `Bearer ${currentUser?.access}` } }
            );
          }
        } catch (se) {
          console.error('Failed to poll stream notifications:', se);
        }

      } catch (err) {
        console.error('Failed to poll for notifications:', err);
      } finally {
        isFetching.current = false;
      }
    };

    // Initial check on mount
    checkNewMessages();

    const interval = setInterval(checkNewMessages, 30000); // Check every 30s instead of 10s
    return () => clearInterval(interval);
  }, [currentUser?.id]); // Only re-run if user changes, not on every navigation

  return null;
};

const App = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <Router>
      <AutoVersionUpdater />
      <ScrollToTop />
      <NotificationHandler />
      <GlobalPopupManager />
      <GlobalStreamingPopup />
      <GlobalBlastQueueWidget />
      <GlobalActiveShippingWidget />
      <UnreviewedOrdersModal />
      <div className="min-h-screen bg-gray-100 dark:bg-gray-950 flex justify-center transition-colors duration-300">
        <Routes>
          <Route path="/*" element={<LayoutWrapper isDesktop={isDesktop} />} />
        </Routes>
      </div>
    </Router>
  );
};

const LayoutWrapper = ({ isDesktop }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  
  const [agreementUser, setAgreementUser] = React.useState(null);
  const [maintenance, setMaintenance] = React.useState(null);

  const fetchMaintenance = React.useCallback(async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/site-content/maintenance/`);
      if (res.data) {
        setMaintenance(res.data);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  React.useEffect(() => {
    fetchMaintenance();
  }, [fetchMaintenance, location.pathname]);

  React.useEffect(() => {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    setAgreementUser(parsedUser);
  }, [location.pathname]);

  const handleAgreementAccepted = () => {
    const updated = JSON.parse(localStorage.getItem('user'));
    setAgreementUser(updated);
  };



  React.useEffect(() => {
    const authPaths = ['/login', '/register', '/lupa-password', '/reset-password'];
    const isAuthPath = authPaths.includes(location.pathname);
    const isWidgetPath = location.pathname.startsWith('/widget');
    if (!isAuthPath && !isWidgetPath) {
      sessionStorage.setItem('lastAccessedPage', location.pathname + location.search);
    }
  }, [location.pathname, location.search]);

  // Check Maintenance Restrictions
  const isAdmin = user && (user.username === 'admin' || user.role === 'admin' || (user.accessible_menus && user.accessible_menus.includes('*')));
  const isAuthRoute = ['/login', '/lupa-password', '/reset-password'].includes(location.pathname);

  // If maintenance is active and user is not admin
  if (maintenance?.is_active && !isAdmin) {
    // If not logged in and not on login page, redirect to login
    if (!user && !isAuthRoute) {
      navigate('/login', { replace: true });
      return null;
    }

    // If logged in as non-admin, block access and display full-screen Maintenance View
    if (user && !isAuthRoute) {
      return <MaintenanceScreen setting={maintenance} onRefresh={fetchMaintenance} />;
    }
  }

  const publicPaths = ['/login', '/register', '/lupa-password', '/reset-password'];
  const showAgreementModal = agreementUser && 
                             !agreementUser.user_agreement_accepted && 
                             !publicPaths.includes(location.pathname) &&
                             !location.pathname.startsWith('/widget');

  return (
    <div className="w-full">
      {/* Sticky Admin Notification when Maintenance Mode is ON */}
      {maintenance?.is_active && isAdmin && (
        <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white text-xs font-bold py-2 px-4 text-center sticky top-0 z-[9999] shadow-md flex items-center justify-center gap-2">
          <span className="material-icons text-sm animate-pulse">engineering</span>
          <span>Mode Maintenance Sedang AKTIF — Website terbuka khusus untuk Administrator.</span>
          <button 
            onClick={() => navigate('/dashboard/admin/maintenance')} 
            className="underline bg-black/20 hover:bg-black/30 px-2 py-0.5 rounded text-[11px] ml-2 transition"
          >
            Pengaturan Maintenance
          </button>
        </div>
      )}

      <ProfileNotice />
      {showAgreementModal && <UserAgreementModal onAccept={handleAgreementAccepted} />}
      <Routes>
        <Route path="/" element={isDesktop ? <DesktopLandingPage /> : <MobileContainer><Home /></MobileContainer>} />

        {/* Account Routes */}
        <Route path="/dashboard/admin/about-us" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAboutUsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/admin/role-management" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardRoleManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/login" element={<MobileContainer><LoginPage /></MobileContainer>} />
        <Route path="/bae-run" element={<BaeRunLandingPage />} />
        <Route path="/register" element={<MobileContainer><RegisterPage /></MobileContainer>} />
        <Route path="/lupa-password" element={<MobileContainer><ForgotPasswordPage /></MobileContainer>} />
        <Route path="/reset-password" element={<MobileContainer><ResetPasswordPage /></MobileContainer>} />
        <Route path="/security/block-device" element={<SecurityDeviceActionPage />} />
        <Route path="/security/confirm-device" element={<SecurityDeviceActionPage />} />


        {/* Logged Account Routes */}
        <Route path="/profile" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ProfilePage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/profile/edit" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ProfileEditPage /></ResponsiveLayout></PrivateRoute>} />

        {/* Crowdfunding Routes */}
        <Route path="/charity" element={<ResponsiveLayout isDesktop={isDesktop}><CrowdfundingMainPage /></ResponsiveLayout>} />
        <Route path="/kampanye/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><CrowdfundingCampaignDetail /></ResponsiveLayout>} />
        <Route path="/bayar-donasi/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><CrowdfundingDonationPage /></ResponsiveLayout>} />
        <Route path="/riwayat-donasi" element={<ResponsiveLayout isDesktop={isDesktop}><CrowdfundingDonationHistoryPage /></ResponsiveLayout>} />
        <Route path="/konfirmasi-pembayaran-donasi" element={<ResponsiveLayout isDesktop={isDesktop}><CrowdfundingPaymentConfirmation /></ResponsiveLayout>} />

        <Route path="/sinergy" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceMainPage /></ResponsiveLayout>} />
        <Route path="/sinergy/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceProductDetail /></ResponsiveLayout>} />
        <Route path="/ecommerce" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceMainPage /></ResponsiveLayout>} />
        <Route path="/ecommerce/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceProductDetail /></ResponsiveLayout>} />
        <Route path="/produk/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceProductDetail /></ResponsiveLayout>} />

        {/* Produk Jasa (Services) Routes */}
        <Route path="/jasa" element={<ResponsiveLayout isDesktop={isDesktop}><ServicesMainPage /></ResponsiveLayout>} />
        <Route path="/jasa/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><ServiceDetailPage /></ResponsiveLayout>} />
        <Route path="/services" element={<ResponsiveLayout isDesktop={isDesktop}><ServicesMainPage /></ResponsiveLayout>} />
        <Route path="/services/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><ServiceDetailPage /></ResponsiveLayout>} />

        {/* Store (Toko Pribadi) & Marketplace Store Routes */}
        <Route path="/store" element={<ResponsiveLayout isDesktop={isDesktop}><EcommerceMainPage /></ResponsiveLayout>} />
        <Route path="/store/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/toko/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/store/toko/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/store/seller/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/incaran" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceWishlistPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/keranjang" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceCartPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/ecommerce/cart" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceCartPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/riwayat-belanja" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceOrderHistoryPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/bayar-belanja" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceCheckoutSinergy /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/ecommerce/checkout" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceCheckoutSinergy /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/ecommerce/checkout-sinergy" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommerceCheckoutSinergy /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/konfirmasi-pembayaran-belanja" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommercePaymentConfirmation /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/pembayaran/:orderNumber" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommercePaymentConfirmation /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/bayar-belanja/:orderNumber" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcommercePaymentConfirmation /></ResponsiveLayout></PrivateRoute>} />

        {/* Article Routes */}
        <Route path="/articles" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleListPage /></ResponsiveLayout>} />
        <Route path="/articles/create" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleCreatePage /></ResponsiveLayout>} />
        <Route path="/articles/:id" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleDetailPage /></ResponsiveLayout>} />
        <Route path="/articles/:id/upload-images" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleUploadImagesPage /></ResponsiveLayout>} />
        <Route path="/academy/articles" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleListPage /></ResponsiveLayout>} />
        <Route path="/academy/articles/:id" element={<ResponsiveLayout isDesktop={isDesktop}><ArticleDetailPage /></ResponsiveLayout>} />

        {/* Ecourse Routes */}
        <Route path="/academy" element={<ResponsiveLayout isDesktop={isDesktop}><AcademyMain /></ResponsiveLayout>} />
        <Route path="/academy/ecourse" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseMainPage /></ResponsiveLayout>} />
        <Route path="/ecourse" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseMainPage /></ResponsiveLayout>} />
        <Route path="/kursus" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseMainPage /></ResponsiveLayout>} />
        <Route path="/kelas" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseMainPage /></ResponsiveLayout>} />
        <Route path="/kelas/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseCourseDetail /></ResponsiveLayout>} />
        <Route path="/ecourse/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseCourseDetail /></ResponsiveLayout>} />
        <Route path="/kursus/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseCourseDetail /></ResponsiveLayout>} />
        <Route path="/academy/ecourse/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EcourseCourseDetail /></ResponsiveLayout>} />
        <Route path="/kelas/buka/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcourseViewerPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/ikut-kelas/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcourseJoinCoursePage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/konfirmasi-pembayaran-kelas/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EcoursePaymentConfirmation /></ResponsiveLayout></PrivateRoute>} />

        {/* Payment Routes */}
        <Route path="/pembayaran-berhasil" element={<ResponsiveLayout isDesktop={isDesktop}><PaymentSuccessPage /></ResponsiveLayout>} />
        <Route path="/pembayaran-gagal" element={<ResponsiveLayout isDesktop={isDesktop}><PaymentFailedPage /></ResponsiveLayout>} />
        <Route path="/pembayaran-tertunda" element={<ResponsiveLayout isDesktop={isDesktop}><PaymentPendingPage /></ResponsiveLayout>} />

        {/* Information Routes */}
        <Route path="/about" element={<ResponsiveLayout isDesktop={isDesktop}><AboutUs /></ResponsiveLayout>} />
        <Route path="/hubungi-kami" element={<ResponsiveLayout isDesktop={isDesktop}><ContactUs /></ResponsiveLayout>} />

        {/* Streaming Route */}
        <Route path="/streaming" element={<ResponsiveLayout isDesktop={isDesktop}><StreamingPage /></ResponsiveLayout>} />

        {/* Activity Routes */}
        <Route path="/kegiatan" element={<ResponsiveLayout isDesktop={isDesktop}><ActivityListPage /></ResponsiveLayout>} />
        <Route path="/kegiatan/:id" element={<ResponsiveLayout isDesktop={isDesktop}><ActivityDetailPage /></ResponsiveLayout>} />
        <Route path="/meetings/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><MeetingViewPage /></ResponsiveLayout>} />

        {/* Event Routes */}
        <Route path="/event" element={<ResponsiveLayout isDesktop={isDesktop}><EventLandingPage /></ResponsiveLayout>} />
        <Route path="/events" element={<ResponsiveLayout isDesktop={isDesktop}><EventLandingPage /></ResponsiveLayout>} />
        <Route path="/event/ajukan" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EventSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/event/edit/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EventSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/event/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><EventDetailPage /></ResponsiveLayout>} />

        {/* Chat Routes */}
        <Route path="/chat" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ChatListPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/chat/:sessionId" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop} hideFooter={true}><ChatWindowPage /></ResponsiveLayout></PrivateRoute>} />

        {/* Forum Routes */}
        <Route path="/forum" element={<ResponsiveLayout isDesktop={isDesktop}><ForumMainPage /></ResponsiveLayout>} />
        <Route path="/forum/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><ForumThreadDetail /></ResponsiveLayout>} />

        {/* Digital Product Routes (Public) */}
        <Route path="/digital-products" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductListPage /></ResponsiveLayout>} />
        <Route path="/produk-digital" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductListPage /></ResponsiveLayout>} />
        <Route path="/digital-products/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductDetailPage /></ResponsiveLayout>} />
        <Route path="/produk-digital/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductDetailPage /></ResponsiveLayout>} />
        <Route path="/digital-products/:slug/checkout" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductCheckoutPage /></ResponsiveLayout>} />
        <Route path="/produk-digital/:slug/checkout" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductCheckoutPage /></ResponsiveLayout>} />
        <Route path="/digital-products/payment/:orderNumber" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductPaymentPage /></ResponsiveLayout>} />

        {/* New Lynk.id style routes & store profile aliases */}
        <Route path="/digital-produk/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/digital-produk/:username/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductDetailPage /></ResponsiveLayout>} />

        {/* Alias routes to support legacy underscore format and prevent blank page */}
        <Route path="/digital_produk/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />
        <Route path="/digital_produk/:username/:slug" element={<ResponsiveLayout isDesktop={isDesktop}><DigitalProductDetailPage /></ResponsiveLayout>} />

        {/* Landing Page Builder Public Route */}
        <Route path="/lp/:slug" element={<PublicLandingPageView />} />

        {/* Catch-all username route for store profile (e.g. /myusername) */}
        <Route path="/:username" element={<ResponsiveLayout isDesktop={isDesktop}><StoreProfilePage /></ResponsiveLayout>} />


        {/* Dashboard Routes (Private) */}
        <Route path="/dashboard" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/shop-settings" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardShopSettingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/payment-settings" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminPaymentSettingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/withdrawals" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminWithdrawalsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/charity" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardRealizationPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/donations" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardDonationManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/partners" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardPartnersPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/testimonials" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardTestimonialsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/activities" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardActivitiesPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/calendar" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ActivityCalendarPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/events" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEventPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/event" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEventPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/event/submissions/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EventRegistrationSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/event/scan/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><EventScanPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/users" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardUserPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/all-products" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminAllProductsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/all-courses" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminAllCoursesPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/consultants" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminConsultantSettingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/transactions" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminTransactionHistoryPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/incoming-funds" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminIncomingFundsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/forum" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminForumPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/roles" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardRoleManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/landing-page-settings" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminLandingPageSettingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/live-streaming" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardLiveStreamingPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/kaderisasi" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardKaderisasiPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/campaign-approval" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminCampaignApprovalPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/service-approval" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminServiceApprovalPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/articles" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminArticleManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/campaigns" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminCampaignManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/photo-framer" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminPhotoFramerPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/event-recap" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEventRecapPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/my-events" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardMyEventsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/business-data" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><BusinessDataListPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/business-data/new" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><BusinessDataFormPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/business-data/edit/:id" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><BusinessDataFormPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/my-campaigns" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardMyCampaignsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/services" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardMyServicesPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/articles" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardArticleEditorPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/articles/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardArticleEditorPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/sinergy/seller" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardSinergySellersPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/sinergy/seller/orders" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardSinergySellerOrdersPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/sinergy" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardSinergyAdminPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/admin/test-expedition" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ExpeditionTestPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/meetings" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardMeetingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/meetings/new" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><MeetingSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/meetings/edit/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><MeetingSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/meetings/manage/:slug" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><MeetingManagementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/digital-products" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardDigitalProductsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/landing-pages" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardLandingPagesPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/landing-pages/builder" element={<PrivateRoute><DashboardLandingPagesBuilderPage /></PrivateRoute>} />
        <Route path="/dashboard/landing-pages/builder/:slug" element={<PrivateRoute><DashboardLandingPagesBuilderPage /></PrivateRoute>} />
        <Route path="/dashboard/ecourses" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEcourseListPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/ecourses/new" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEcourseFormPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/ecourses/:id/edit" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEcourseFormPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/ecourses/:id/materials" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEcourseMaterialsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/ecourses/:courseId/progress" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardEcourseProgressPage /></ResponsiveLayout></PrivateRoute>} />
        
        {/* ZIS Rutin Routes */}
        <Route path="/dashboard/zis" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ZISSubmissionPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/zis/history" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><ZISHistoryPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/zis-config" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminZISConfigPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/zis-verify" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><AdminZISVerifyPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/announcements" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAnnouncementsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/hero-banners" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardHeroBannersPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/business-partners" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminBusinessPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/user-agreement" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardUserAgreementPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/maintenance" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardAdminMaintenancePage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/whats-new" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardWhatsNewPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/broadcast-wa" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardBroadcastWAPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/broadcast-email" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardBroadcastEmailPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/dashboard/admin/whatsapp-settings" element={<PrivateRoute><ResponsiveLayout isDesktop={isDesktop}><DashboardWhatsAppSettingsPage /></ResponsiveLayout></PrivateRoute>} />
        <Route path="/whats-new" element={<ResponsiveLayout isDesktop={isDesktop}><WhatsNewPage /></ResponsiveLayout>} />

        <Route path="/live-meet-test" element={<ResponsiveLayout isDesktop={isDesktop}><AdminJitsiMeetPage /></ResponsiveLayout>} />

        {/* Widget Routes — standalone, auth dikelola di dalam komponen */}
        <Route path="/widget/calendar" element={<CalendarWidgetPage />} />
      </Routes>
      <SlideOverCartDrawer />
      <WhatsNewPopup />
    </div>

  );
};

export default App;
